import { render, staticRenderFns } from "./ScreenAcortador.vue?vue&type=template&id=608582ec&scoped=true"
import script from "./ScreenAcortador.vue?vue&type=script&lang=js"
export * from "./ScreenAcortador.vue?vue&type=script&lang=js"
import style0 from "./ScreenAcortador.vue?vue&type=style&index=0&id=608582ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608582ec",
  null
  
)

export default component.exports